module.exports = __webpack_public_path__ + "img/title.4c02531e.png";